export default {
  'invoice.create': 'Criar Nota Fiscal',
  'invoice.create.notification.success': 'Sucesso',
  'invoice.create.notification.successDescription': 'Nota Fiscal Criada!',
  'invoice.create.notification.successDescription.edit': 'Nota Fiscal Editada!',

  'invoice.create.notification.additionalData.edit':
    'Dados Adicionais Editado!',

  'invoice.column.table.invoiceNumber': 'Número',
  'invoice.column.table.series': 'Série',
  'invoice.column.table.issuanceDate': 'Dt. Emissão',
  'invoice.column.table.recipient': 'Destinatário',
  'invoice.column.table.situation': 'Situação',
  'invoice.column.table.key': 'Chave NF-e',
  'invoice.column.table.supplierName': 'Fornecedor',

  'invoice.column.table.situation.replaced': 'Substituição',
  'invoice.column.table.situation.inTyping': 'Em digitação',
  'invoice.column.table.situation.validated': 'Validada',
  'invoice.column.table.situation.processing': 'processamento',
  'invoice.column.table.situation.authorized': 'Autorizada',
  'invoice.column.table.situation.canceled': 'Cancelada',

  'invoice.domain.company': 'Empresa',
  'invoice.domain.model': 'Modelo',
  'invoice.domain.series': 'Série',
  'invoice.domain.number': 'Número',
  'invoice.domain.invoiceKey': 'Chave Nota Fiscal',
  'invoice.domain.destination': 'Natureza da operação',
  'invoice.domain.emissionGoals': 'Finalidade de emissão',
  'invoice.domain.emissionGoals.normalNfe': '1 - NF-e Normal',
  'invoice.domain.emissionGoals.additionalNfe': '2 - NF-e Complementar',
  'invoice.domain.emissionGoals.adjustmentNfe': '3 - NF-e Ajuste',
  'invoice.domain.emissionGoals.merchandiseReturnNfe':
    '4 - NF-e Devolução de Mercadoria',
  'invoice.domain.situation': 'Situação',
  'invoice.domain.situation.initialValue': 'Em digitação',
  'invoice.domain.emissionDate': 'Data de Emissão',
  'invoice.domain.documentType': 'Tipo de Documento',
  'invoice.domain.documentType.entry': '0 - Entrada',
  'invoice.domain.documentType.exit': '1 - Saída',
  'invoice.domain.finalCostumer': 'Consumidor Final',
  'invoice.domain.true': 'Sim',
  'invoice.domain.false': 'Não',
  'invoice.domain.operationDestination': 'Destino Operação',
  'invoice.domain.operationDestination.internalOperation':
    '1 - Operação Interna',
  'invoice.domain.operationDestination.interstateOperation':
    '2 - Operação Interestadual',
  'invoice.domain.operationDestination.foreignOperation':
    '3 - Operação com exterior',
  'invoice.domain.entryExitDate': 'Data entrada/saída',
  'invoice.domain.emissionType': 'Tipo Emissão',
  'invoice.domain.emissionType.normal': '1 - Emissão Normal',
  'invoice.domain.emissionType.contingencyFs':
    '2 - Contingência FS-IA, com impressão do DANFE em formulário de segurança',
  'invoice.domain.emissionType.contingencyDpec':
    '4 - Contingência DPEC (Declaração Prévia de Emissão em Contingência)',
  'invoice.domain.emissionType.contingencyFsda':
    '5 - Contingência FS-DA, com impressão do DANFE em formulário de segurança',
  'invoice.domain.emissionType.contingencySvcan':
    '6 - Contingência SVC-AN (SEFAZ Virtual de Contingência do AN)',
  'invoice.domain.emissionType.contingencySvcrs':
    '7 - Contingência SVC-RS (SEFAZ Virtual de Contingência do RS)',
  'invoice.domain.presenceIndicator': 'Indicador Presença',
  'invoice.domain.presenceIndicator.notApplicable': '0 - Não se aplica',
  'invoice.domain.presenceIndicator.faceToFaceOperation':
    '1 - Operação presencial',
  'invoice.domain.presenceIndicator.nonFaceToFaceOperationOverTheInternet':
    '2 - Operação não presencial, pela Internet',
  'invoice.domain.presenceIndicator.nonFaceToFaceOperationCallCenter':
    '3 - Operação não presencial, Teleatendimento',
  'invoice.domain.presenceIndicator.faceToFaceOperationOffSite':
    '5 - Operação presencial, fora do estabelecimento',
  'invoice.domain.presenceIndicator.nonFaceToFaceOperationOthers':
    '9 - Operação não presencial, outros.',
  'invoice.domain.uf': 'UF',
  'invoice.domain.municipalityOccurrence': 'Município de Ocorrência',
  'invoice.domain.brokerIndicator': 'Indicador de Intermediador',
  'invoice.domain.freightIcmsSt':
    'Frete, Despesas entram na base de cálculo ICMS ST',
  'invoice.domain.freightIpi': 'Frete, Despesas entram na base de cálculo IPI',

  'invoice.nfe.recipient.form.recipientType': 'Tipo Destinatário',
  'invoice.nfe.recipient.form.recipientType.customer': 'Cliente',
  'invoice.nfe.recipient.form.recipientType.supplier': 'Fornecedor',
  'invoice.nfe.recipient.form.recipientType.insurer': 'Seguradora',
  'invoice.nfe.recipient.form.cpf/cnpj': 'CPF/CNPJ',
  'invoice.nfe.recipient.form.provider': 'Fornecedor',
  'invoice.nfe.recipient.form.typeOfTaxpayers': 'Tipo de Contribuintes',
  'invoice.nfe.recipient.form.typeOfTaxpayers.contributorIcms':
    'Contribuinte ICMS',
  'invoice.nfe.recipient.form.typeOfTaxpayers.contributorExempt':
    'Contribuinte Isento',
  'invoice.nfe.recipient.form.typeOfTaxpayers.nonTaxpayer': 'Não Contribuinte',
  'invoice.nfe.recipient.form.title':
    'Informações do Intermediador da Transação',
  'invoice.nfe.recipient.form.processedByIntermediary':
    'Processado Pelo Intermediador?',
  'invoice.nfe.recipient.form.processedByIntermediary.yes': 'Sim',
  'invoice.nfe.recipient.form.processedByIntermediary.no': 'Não',
  'invoice.nfe.recipient.form.intermediaryCnpj': 'CNPJ do intermediador',
  'invoice.nfe.recipient.form.SellerId': 'Identificação do Vendedor',
  'invoice.nfe.recipient.form.btn.save': 'Salvar',
  'invoice.nfe.recipient.form.btn.comeBack': 'Voltar',
  'invoice.nfe.recipient.form.btn.referringOs': 'O.S referente',

  'invoice.nfse.recipient.form.btn.save': 'Salvar',
  'invoice.nfse.recipient.form.btn.comeBack': 'Voltar',
  'invoice.nfse.recipient.form.btn.transmit': 'Transmitir',
  'invoice.nfse.recipient.form.btn.consultStatus': 'Consultar Situação',
  'invoice.nfse.recipient.form.btn.cancelNote': 'Cancelar Nota',
  'invoice.nfse.recipient.form.btn.referringOs': 'O.S Referente',

  'invoice.nfse.domain.numberRps': 'Número RPS',
  'invoice.nfse.domain.destination.taxationMunicipality':
    '1 - Tributação no Município',
  'invoice.nfse.domain.destination.taxationOutsideMunicipality':
    '2 - Tributação fora do Município',
  'invoice.nfse.domain.destination.immunity': '3 - Isenção',
  'invoice.nfse.domain.destination.immune': '4 - Imune',
  'invoice.nfse.domain.destination.courtDecision':
    '5 - Exigibilidade suspensa por decisão judicial',
  'invoice.nfse.domain.destination.administrativeProcedure':
    '6 - Exigibilidade suspensa por procedimento administrativo',
  'invoice.nfse.domain.municipalTaxCode': 'Código tributação municipal',
  'invoice.nfse.domain.simpleNational': 'Simples Nacional',
  'invoice.nfse.domain.culturalIncentive': 'Incentivo Cultural',
  'invoice.nfse.domain.IssWithheld': 'ISS Retido',
  'invoice.nfse.domain.deductIss': 'Deduzir ISS',
  'invoice.nfse.domain.pisCofinsWithholding': 'Retenção PIS/COFINS',
  'invoice.nfse.domain.additionalInformation': 'Informações Adicionais',
  'invoice.nfse.domain.description':
    'Descrição do RPS e serviços prestados. Usar o Pipe "|" para quebra de linha',

  'invoice.nfse.filters.situation.replaced': 'Substituída',
  'invoice.nfse.filters.situation.inTyping': 'Em Digitação',
  'invoice.nfse.filters.situation.validated': 'Validada',
  'invoice.nfse.filters.situation.processing': 'Em Processamento',
  'invoice.nfse.filters.situation.authorized': 'Autorizada',
  'invoice.nfse.filters.situation.canceled': 'Cancelada',
  'invoice.nfse.filters.situation.denied': 'Denegada',
  'invoice.nfse.filters.situation.interrupted': 'Interrompida',

  'invoice.nfse.filters.type.nfe': 'NFe',
  'invoice.nfse.filters.type.nfce': 'NFCe',
  'invoice.nfse.filters.type.nfse': 'NFSe',

  'invoice.disableNumberingRange.helmet.title': 'Inutilizar Faixa de Numeração',
  'invoice.disableNumberingRange.btn.newDisability': 'Inutilizar Numeração',
  'invoice.disableNumberingRange.form.company': 'Empresa',
  'invoice.disableNumberingRange.form.series': 'Série',
  'invoice.disableNumberingRange.form.model': 'Modelo',
  'invoice.disableNumberingRange.form.startingNumber': 'Número inicial',
  'invoice.disableNumberingRange.form.finalNumber': 'Número final',
  'invoice.disableNumberingRange.form.btn.comeBack': 'Voltar',
  'invoice.disableNumberingRange.form.btn.search': 'Buscar',
  'invoice.disableNumberingRange.form.btn.disable': 'Inutilizar',
  'invoice.disableNumberingRange.form.modalJustification.title':
    'Justificativa da Inutilização',
  'invoice.disableNumberingRange.form.modalJustification.label':
    'Justificativa da inutilização, informe no mínimo 15 caracteres',
  'invoice.disableNumberingRange.table.model': 'Modelo',
  'invoice.disableNumberingRange.table.series': 'Série',
  'invoice.disableNumberingRange.table.dateOfDisability':
    'Data da Inutilização',
  'invoice.disableNumberingRange.table.initialNumber': 'Número Inicial',
  'invoice.disableNumberingRange.table.finalNumber': 'Número Final',

  'invoice.disableNumberingRange.list.table.company': 'Empresa',
  'invoice.disableNumberingRange.list.table.model': 'Modelo',
  'invoice.disableNumberingRange.list.table.series': 'Série',
  'invoice.disableNumberingRange.list.table.dateOfDisability':
    'Data da Inutilização',
  'invoice.disableNumberingRange.list.table.initialNumber': 'Número inicial',
  'invoice.disableNumberingRange.list.table.finalNumber': 'Número Final',
  'invoice.disableNumberingRange.filter.company': 'Empresa',
  'invoice.disableNumberingRange.filter.model': 'Modelo',
  'invoice.disableNumberingRange.filter.series': 'Série',
  'invoice.disableNumberingRange.filter.dateOfDisability':
    'Data da Inutilização',
  'invoice.disableNumberingRange.filter.initialNumber': 'Número inicial',
  'invoice.disableNumberingRange.filter.finalNumber': 'Número Final',

  'invoice.sintegra.create.generateFile': 'Gerar Arquivo',
  'invoice.sintegra.helmet.title': 'Sintegra',
  'invoice.sintegra.form.initialDate': 'Data Inicial',
  'invoice.sintegra.form.finalDate': 'Data Final',
  'invoice.sintegra.form.company': 'Empresa',
  'invoice.sintegra.form.radioGroup.noteType.title': 'Tipo de Nota',
  'invoice.sintegra.form.radio.partsAndServices': 'Peças e Serviços',
  'invoice.sintegra.form.radio.parts': 'Peças',
  'invoice.sintegra.form.radio.services': 'Serviços',
  'invoice.sintegra.form.radioGroup.filter.title': 'Filtrar Compra por Data',
  'invoice.sintegra.form.radio.launch': 'Lançamento',
  'invoice.sintegra.form.radio.issue': 'Emissão',
  'invoice.sintegra.form.checkbox.generateRecord74': 'Gerar Registro 74',
  'invoice.sintegra.form.checkbox.generateRecord61R': 'Gerar Registro 61R',
  'invoice.sintegra.form.inventoryData': 'Buscar dados de inventário de:',
  'invoice.sintegra.form.inventoryDate': 'Data do  Inventário',
  'invoice.sintegra.form.PurposeOfPresentation':
    'Finalidade da Apresentação do Arquivo Eletrônico',
  'invoice.sintegra.form.checkbox.removeParts': 'Remover Estereótipo de Peças',
  'invoice.sintegra.form.checkbox.removeInputs':
    'Remover Estereótipo de Insumos',
  'invoice.sintegra.form.select.currentStock': 'Estoque atual',
  'invoice.sintegra.form.select.inventory': 'Inventário',
  'invoice.sintegra.form.select.normal': 'Normal',
  'invoice.sintegra.form.select.fullFileRectification':
    'Retificação total de arquivo',

  'invoice.xml.helmet.title': 'Baixar Arquivo XML',
  'invoice.xml.form.company': 'Empresa',
  'invoice.xml.form.initialDate': 'Data Inicial',
  'invoice.xml.form.finalDate': 'Data Final',
  'invoice.xml.form.btn.search': 'Buscar',

  'invoice.manifestationRecipient.helmet.title': 'Manifestação do Destinatário',
  'invoice.manifestationRecipient.form.company': 'Empresa',
  'invoice.manifestationRecipient.form.btn.manifestSelectedNote':
    'Manifestar Nota',
  'invoice.manifestationRecipient.form.btn.searchNotesManifest':
    'Pesquisar notas a manifestar',
  'invoice.manifestationRecipient.table.situation': 'Situação',
  'invoice.manifestationRecipient.table.manifestation': 'Manifestação',
  'invoice.manifestationRecipient.table.issue': 'Emissão',
  'invoice.manifestationRecipient.table.NFeKey': 'Chave NF-e',
  'invoice.manifestationRecipient.table.NFeAcessKey': 'Chave de acesso da NF-e',
  'invoice.manifestationRecipient.table.lastNSU': 'Último NSU recebido',
  'invoice.manifestationRecipient.table.provider': 'Fornecedor',
  'invoice.manifestationRecipient.table.value': 'Valor',
  'invoice.manifestationRecipient.modal.title': 'Manifestação do Destinatário',
  'invoice.manifestationRecipient.modal.manifestation': 'Manifestação',
  'invoice.manifestationRecipient.modal.withoutManifestation':
    'Sem Manifestação',
  'invoice.manifestationRecipient.modal.confirmed': 'Confirmada',
  'invoice.manifestationRecipient.modal.unknown': 'Desconhecida',
  'invoice.manifestationRecipient.modal.notPerformed': 'Não Realizada',
  'invoice.manifestationRecipient.modal.aware': 'Ciente',
  'invoice.manifestationRecipient.modal.date': 'Data',
  'invoice.manifestationRecipient.modal.btn.transmit': 'Transmitir',

  'invoice.create.modal': 'Criação Inicial da Nota',
  'invoice.create.modal.step.select': 'Selecione',
  'invoice.create.modal.step.select.description':
    'Selecione o Tipo de Nota que deseja criar',
  'invoice.create.modal.step.dataInvoice': 'Criação',
  'invoice.create.modal.step.dataInvoice.description':
    'Crie os dados da Nota Fiscal',
  'invoice.create.modal.step.reciptient': 'Criação',
  'invoice.create.modal.step.reciptient.description': 'Criação do Destinatário',

  'invoice.create.modal.invoiceType.nfe': 'Nota Fiscal Eletrônica',
  'invoice.create.modal.invoiceType.nfce': 'Nota Fiscal de Consumidor',
  'invoice.create.modal.invoiceType.nfse': 'Nota Fiscal de Serviço',
  'invoice.create.modal.invoiceType.cfe': 'Cupom Fiscal',

  'invoice.createadditionalData.additionalPhysicalInformation':
    'Informações Adicionais de Interesse do Fisco',
  'invoice.createadditionalData.AdditionalTaxpayerInformation':
    'Informações Adicionais de Interesse do Contribuinte',
  'invoice.createadditionalData.btn.save': 'Salvar',
  'invoice.createadditionalData.btn.comeBack': 'Salvar',
  'invoice.createadditionalData.btn.referentialOS': 'O.S referenciada',
  'invoice.createadditionalData.modal.title': 'Informação',
  'invoice.createadditionalData.modal.title.1':
    '1 - @{codigoOS} - Essa tag será substituida pelo código da O.S.',
  'invoice.createadditionalData.modal.title.2':
    '2 - @{descricaoVeiculo} -  Essa tag será substituida pela descrição do veículo.',
  'invoice.createadditionalData.modal.title.3':
    '3 - @{placa} - Essa tag será substituida pela placa do veículo.',
  'invoice.createadditionalData.modal.title.4':
    '4 - @{chassi} - Essa tag será substituida pelo chassi do veículo.',
  'invoice.createadditionalData.modal.title.5':
    '5 - @{sinistro} - Essa tag será substituida pelo número do sinistro.',
  'invoice.createadditionalData.modal.title.6':
    '6 - @{km} - Essa tag será substituida pelo número de km.',
  'invoice.createadditionalData.modal.title.7':
    '7 - @{kmSaida} - Essa tag será substituida pelo número de km de saída.',
  'invoice.createadditionalData.modal.title.8':
    '8 - @{ValorTributisAproximado} - Essa tag será substituida pela incidência do percentual de tributos sobre valores da NFS-e.',
  'invoice.createadditionalData.modal.title.9':
    '9 - @{totalIR} - Essa tag será substituida pelo somatório dos valores de IRPJ dos itens da nota',
  'invoice.createadditionalData.modal.title.10':
    '10 - @{totalCSLL} - Essa tag será substituida pelo somatório dos valores de CSLL dos itens da nota',
  'invoice.createadditionalData.modal.title.11':
    '11 - @{totalPIS} - Essa tag será substituida pelo somatório dos valores de PIS dos itens da nota',
  'invoice.createadditionalData.modal.title.12':
    '12 - @{totalCofins} - Essa tag será substituida pelo somatório dos valores de Cofins dos itens da nota',
  'invoice.createadditionalData.modalOs.title': 'O.S referente nota fiscal',
  'invoice.createadditionalData.modalOs.nOs': 'N° O.S',
  'invoice.createadditionalData.modalOs.client': 'Cliente',

  'invoice.notifications.create.success.title': 'Sucesso!',
  'invoice.notifications.create.success.description':
    'Nota Fiscal criada com sucesso!',
  'invoice.notifications.transmit.success.description':
    'Nota Fiscal enviada para transmissão com sucesso!',
  'invoice.notifications.cancel.success.description':
    'Nota Fiscal cancelada com sucesso!',
  'invoice.notifications.cce.create.success.description':
    'Carta de correção de estoque criada com sucesso!',

  'invoice.remove.notification.success': 'Sucesso',
  'invoice.remove.notification.successDescription': 'Nota Fiscal removida.',
  'invoice.remove.confirm.title': 'Remover nota fiscal',
  'invoice.remove.confirm.description':
    'Deseja realmente remover a nota fiscal selecionada?',

  'invoice.note.items.notifications.remove.confirm.title':
    'Você deseja realmente excluir esse Item?',
  'invoice.note.items.notifications.remove.confirm.content':
    'Ao remover o Item, todas as informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'invoice.note.items.remove.notification.successDescription':
    'Item da Nota Fiscal removido com sucesso!',
  'invoice.note.items.edit.notification.successDescription':
    'Item da Nota Fiscal editado!',

  'invoice.create.referenceDocument.table.type': 'Tipo',
  'invoice.create.referenceDocument.table.model': 'Modelo',
  'invoice.create.referenceDocument.table.series': 'Série',
  'invoice.create.referenceDocument.table.number': 'Número',
  'invoice.create.referenceDocument.table.issuer': 'Emitente',
  'invoice.create.referenceDocument.table.acessKey': 'Chave de Acesso',
  'invoice.create.referenceDocument.table.issueDate': 'Data de Emissão',
  'invoice.create.referenceDocument.table.uf': 'UF',

  'invoice.create.referenceDocument.select.selectCashier': 'Selecione a Caixa',
  'invoice.remove.notification.success': 'Sucesso',
  'invoice.status.message.success': 'Nota fiscal removida',

  'invoice.situation': 'Situation: ',
  'invoice.situation.REPLACED': 'SUBSTITUÍDA',
  'invoice.situation.IN_TYPING': 'EM DIGITAÇÃO',
  'invoice.situation.VALIDATED': 'VALIDADA',
  'invoice.situation.PROCESSING': 'PROCESSANDO',
  'invoice.situation.AUTHORIZED': 'AUTORIZADA',
  'invoice.situation.CANCELED': 'CANCELADA',
  'invoice.situation.PROCESSING_CANCELLATION': 'EM CANCELAMENTO',
  'invoice.situation.DENIED': 'DENEGADA',
  'invoice.situation.INTERRUPTED': 'INTERROMPIDA',

  'invoice.referencedDocument.create.success.title': 'Sucesso!',
  'invoice.referencedDocument.create.success.description':
    'Documento Referenciado criado com sucesso!',
  'invoice.referencedDocument.delete.success.description':
    'Documento Referenciado removido com sucesso!',
  'invoice.referencedDocument.update.success.description':
    'Documento Referenciado atualizado com sucesso!',
};
